import { Box, Button, Typography, Stack } from '@mui/material'
import React, { useState } from 'react'

function ProductDescription({ details, mt }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const shortDetails = `${details.substring(0, 100)}...`;
  return (
    <Stack mt={mt}>
      <Typography sx={{ fontSize: 14, fontWeight: 500, marginBottom: 0.5, mt: 1 }}> Product Description</Typography>
      <Box>
        <Typography sx={{ fontSize: 12, fontWeight: 400, color: "rgba(0,0,0,0.8)", }}>
          {isExpanded ? details : shortDetails}
        </Typography>
        {details.length > 100 && (
          <Button onClick={() => setIsExpanded(!isExpanded)} sx={{ color: "rgba(53, 65, 236, 1)", fontSize: 12, fontWeight: 400 }} size="small">
            {isExpanded ? "Show Less" : "Show More"}
          </Button>
        )}
      </Box>
    </Stack>
  )
}



export default ProductDescription
